import React, { useContext } from "react"
import BlockHelpContainer from '../containers/BlockHelpContainer'
import HelpIcon from './HelpIcon';
import { FaqContext } from "../context";

function ElementHelp(props) {

    const {changeHelpRenderState, faqList} = useContext(FaqContext);


    if(faqList){
    return (
        <>
            <HelpIcon
                slug={props.slug}
                faqList={faqList}
                changeHelpRenderState={changeHelpRenderState}
            />

        <BlockHelpContainer slug={props.slug}/>
        </>
    )}else
        return null
}

export default ElementHelp;